import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import LocalSpinner from "../../../../components/LocalSpinner";
import { getFormattedNumValue } from "../../../../utils";
import { ChartPieSlice, Crosshair, TrendDown, TrendUp } from "@phosphor-icons/react";
import DashboardCard from "../../../ISSB/Dashboard/components/DashboardCard";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../config";

const AttributedEmissions = ({ isLoading, currentYear, previousYear, theme = "light" }) => {
  const navigate = useNavigate();

  const colors = {
    light: {
      cardBg: "#F7FAFC",
      title: "teal",
      value: "gray.800",
      percentUp: "status.red",
      percentDown: "status.green",
    },
    dark: {
      cardBg: "pureBlack",
      title: "pureWhite",
      value: "lightLime",
      percentUp: "status.red",
      percentDown: "status.green",
    },
  };
  const t = colors[theme] || colors.light;

  let basePercentageChange = 0;
  // perchange change of totalEmissions from previousYear to currentYear
  if (previousYear && previousYear.totalEmissions) {
    const previousEmissions = previousYear?.totalEmissions || 0;
    const currentEmissions = currentYear?.totalEmissions || 0;
    basePercentageChange = ((currentEmissions - previousEmissions) / previousEmissions) * 100;
  }

  let delta = currentYear?.totalTarget
    ? ((currentYear?.totalEmissions - currentYear?.totalTarget) / currentYear?.totalTarget) * 100
    : 0;

  return (
    <DashboardCard bg={t.cardBg} px={6} onClick={() => navigate(routes.supplierInsightEmissionDetail)}>
      <Text fontSize="body.m" fontWeight="bold" color={t.title}>
        Supplier Attributed Emissions
      </Text>
      {isLoading ? (
        <LocalSpinner size="sm" />
      ) : (
        <Flex direction="column" gap={8} height="100%" justify="space-between">
          <Box color="teal" mb={4}>
            <Heading fontSize="heading.2xl" >
              <Text as="span" fontSize="heading.3xl" fontWeight="bold" color={t.value}>
                {getFormattedNumValue(currentYear?.totalEmissions, 2, true) || 0}
              </Text>{" "}
              <Text as="span" fontSize="body.m" color={t.value}>
                tCO2e
              </Text>
            </Heading>
          </Box>

          <Box>
            <Text fontSize="heading.s" fontWeight="bold">
              Spend Intensity
            </Text>
            <Text fontSize="heading.xl" fontWeight="bold">
              {getFormattedNumValue(currentYear?.spendIntensity, 2, true) || 0}
            </Text>
            <Text>tCO2e/£1m spend</Text>
          </Box>

          <Box mt={4}>
            <Flex
              direction="row"
              width="100%"
              // px="15%"
              justifyContent="space-between"
            >
              <Text
                display="flex"
                gap={1}
                color={basePercentageChange >= 0 ? t.percentUp : t.percentDown}
                fontSize="heading.s"
                fontWeight="bold"
              >
                {basePercentageChange >= 0 ? (
                  <TrendUp size={18} weight="bold" />
                ) : (
                  <TrendDown size={18} weight="bold" />
                )}
                {getFormattedNumValue(basePercentageChange, 2) || 0} %
              </Text>
              <Text
                display="flex"
                gap={1}
                fontSize="heading.s"
                color={basePercentageChange >= 0 ? t.percentUp : t.percentDown}
                fontWeight="bold"
              >
                <Crosshair size={18} weight="bold" />
                {getFormattedNumValue(delta, 2) || 0} %
              </Text>
            </Flex>
          </Box>
        </Flex>
      )}
    </DashboardCard>
  );
};

export default AttributedEmissions;
